"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactSmoothCollapse = _interopRequireDefault(require("react-smooth-collapse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Accordion = function Accordion(props) {
  var customOpen = props.customOpen,
      defaultOpen = props.defaultOpen,
      onClose = props.onClose,
      title = props.title,
      children = props.children,
      style = props.style,
      headerStyle = props.headerStyle,
      bodyStyle = props.bodyStyle,
      className = props.className,
      onHeaderClick = props.onHeaderClick;
  var initialOpen = customOpen || defaultOpen;

  var _useState = (0, _react.useState)(initialOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!open) {
      onClose && onClose();
    }
  }, [onClose, open]);

  var onLocalHeaderClick = function onLocalHeaderClick(event) {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
    onHeaderClick(event, open);
  };

  (0, _react.useEffect)(function () {
    setOpen(customOpen || defaultOpen);
  }, [customOpen, defaultOpen]);
  return _react["default"].createElement("div", {
    className: "accordion".concat(open ? ' accordion-open ' : ' ').concat(className),
    style: style
  }, _react["default"].createElement("div", {
    className: "accordion-header",
    onClick: onLocalHeaderClick,
    style: headerStyle
  }, _react["default"].createElement("div", {
    className: "accordion-arrow"
  }, _react["default"].createElement("i", {
    className: "fa fa-lg fa-angle-".concat(open ? 'down' : 'right')
  })), title), _react["default"].createElement(_reactSmoothCollapse["default"], {
    expanded: open
  }, _react["default"].createElement("div", {
    className: "accordion-body",
    style: bodyStyle
  }, children)));
};

Accordion.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  defaultOpen: _propTypes["default"].bool,
  customOpen: _propTypes["default"].bool,
  style: _reactStyleProptype["default"],
  headerStyle: _reactStyleProptype["default"],
  bodyStyle: _reactStyleProptype["default"],
  className: _propTypes["default"].string,
  onHeaderClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Accordion.defaultProps = {
  defaultOpen: false,
  onHeaderClick: function onHeaderClick() {
    return undefined;
  },
  style: {},
  headerStyle: {},
  bodyStyle: {},
  className: ''
};
var _default = Accordion;
exports["default"] = _default;